import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { Arrow } from "app/components/Arrow/Arrow";
import { CHART_COLORS } from "app/constants/ChartColors";
import { translate } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";

import {
    ChartHeaderText,
    ChartImageSection,
    ChartImageSectionText,
    ChartImageSectionWrapper,
    ChartItemText,
    DataSection,
    DataSectionAmountText,
    DataSectionHeaderText,
    DataSectionSubtextText,
    DataSectionWrapper,
    Ellipsis,
} from "./StyledAIReportCtaSectionImages";
import { AI_REPORT_CTA_SECTION_IMAGES_TRANSLATIONS } from "./translations";

const CHART_IMAGE = "/images/ai-report-cta-section/chart.png";

const ChartItem = ({ index, color }: { index: number; color: string }) => {
    return (
        <Flex
            gap="4px"
            alignItems="center"
        >
            <Ellipsis $color={color} />

            <ChartItemText>
                {translate(AI_REPORT_CTA_SECTION_IMAGES_TRANSLATIONS.CHART_ITEM_TEXT, { index })}
            </ChartItemText>
        </Flex>
    );
};

export const AIReportCtaSectionImages = () => {
    return (
        <Flex>
            <ChartImageSectionWrapper>
                <ChartImageSection>
                    <ChartImageSectionText>
                        <ChartHeaderText>
                            {translate(AI_REPORT_CTA_SECTION_IMAGES_TRANSLATIONS.CHART_HEADER_TEXT)}
                        </ChartHeaderText>

                        <Flex
                            gap="10px"
                            alignItems="center"
                            justifyContent="center"
                        >
                            {CHART_COLORS.competitorsColors.slice(0, 5).map((color, index) => (
                                <ChartItem
                                    key={index}
                                    index={index + 1}
                                    color={color}
                                />
                            ))}
                        </Flex>
                    </ChartImageSectionText>

                    <img
                        alt="chart"
                        src={AssetsService.assetUrl(CHART_IMAGE)}
                    />
                </ChartImageSection>
            </ChartImageSectionWrapper>

            <DataSectionWrapper>
                <DataSection>
                    <DataSectionHeaderText>
                        {translate(AI_REPORT_CTA_SECTION_IMAGES_TRANSLATIONS.DATA_SECTION_HEADER_TEXT)}
                    </DataSectionHeaderText>

                    <DataSectionAmountText>
                        24.1K{" "}
                        <Arrow
                            color={colorsPalettes.green[300]}
                            size={30}
                        />
                    </DataSectionAmountText>

                    <DataSectionSubtextText>
                        {translate(AI_REPORT_CTA_SECTION_IMAGES_TRANSLATIONS.DATA_SECTION_SUBTEXT_TEXT)}
                    </DataSectionSubtextText>
                </DataSection>
            </DataSectionWrapper>
        </Flex>
    );
};
